import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { json } from '../assets/data/routemee';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private titleService: Title) {
    this.titleService.setTitle(json.title);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/app.component.ts